export default __webpack_public_path__ + "static/media/recibo-mobile.9797f47d.png";